<div>
  <legend>{{ 'tkey;reports.microsoft.custom_powershell_reports.header' | translate }}</legend>
  <ziro-text fieldId="reportName"></ziro-text>
  <ziro-code-area fieldId="pwshQuery"></ziro-code-area>
  <div class="row">
    <div class="col-lg-9 offset-lg-3">
      <span>{{ 'tkey;reports.microsoft.custom_powershell_reports.form.pwsh_query.helptext_1' | translate }}</span>
      <button
        type="button"
        class="btn btn-border btn-link ps-1 pe-1 test-query-link text-decoration-none"
        data-automation="powershell-report-test-query-link-button"
        [disabled]="isQueryRunning"
        (click)="onTestQueryClick()"
      >
        {{ 'tkey;reports.microsoft.custom_powershell_reports.form.pwsh_query.helptext_2' | translate }}
      </button>
      <span>{{ 'tkey;reports.microsoft.custom_powershell_reports.form.pwsh_query.helptext_3' | translate }}</span>
    </div>
  </div>
</div>

@if (hasQueryRun || isQueryRunning || queryResults.length > 0) {
  <legend id="custom-powershell-queries-results-header">
    {{ 'tkey;reports.microsoft.custom_powershell_reports.form.table.title' | translate }}
  </legend>
}

<ziro-loading-block [hidden]="!isQueryRunning"></ziro-loading-block>

@if (!isQueryRunning && hasQueryRun) {
  <ziro-datatable
    [class]="'ziro-card'"
    [isCondensed]="true"
    [dataAutomation]="tableDataAutomation"
    [minTableHeight]="'20rem'"
    [noResultsAlert]="'tkey;reports.microsoft.custom_powershell_reports.form.table.no_results'"
    [columns]="columns"
    [rowDataSource]="tableData"
    [uniqueRowIdentifier]="null"
  ></ziro-datatable>
}
